module.exports = __webpack_public_path__ + "static/media/tinywow_2582Salixsp_colored_55475635.632de571.jpg";